// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"569":"e6bc5276","861":"bda88168"}[chunkId] + ".chunk.css";
};